import * as actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  taskMonitorObject: {},
  taskMonitorResultObject: {},
  geoIdMap: {}
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/app/taskMonitor/vuex/index.js